module.exports = __webpack_public_path__ + "static/media/f4d-black-transparent-p-800.118fcfe5.png";